// extracted by mini-css-extract-plugin
export default {"tab":"tab","selected":"selected"};